import { mapState } from 'vuex';
import {
  BuildingDTO,
  EntrancePlantDetailDTO,
} from '@/../client-generator/generated-clients/plants';
import { Options, Vue } from 'vue-class-component';
import BuildingItem from '../../../EntrancePlantSettings/EntrancePlantStructure/BuildingItem/BuildingItem.vue';

@Options({
  name: 'BuildingSelector',
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  components: {
    BuildingItem,
  },
  emits: ['building-selected'],
})
export default class BuildingSelector extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;

  buildingSelected(building: BuildingDTO) {
    this.$emit('building-selected', building);
  }
}
